<template>
  <div>
    <common-dialog
      ref="dialog"
      width="550px"
      show-save-button
      unit="宿舍"
      id-key="DormitoryId"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="isCreate?api.add:api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="宿舍地址" prop="DormitoryAddr">
                <el-input size="mini" v-model="data.DormitoryAddr" placeholder="请填写宿舍地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="容纳人数" prop="Capacity">
                <el-input size="mini" v-model="data.Capacity" type="number" oninput ="value=value.replace(/[^\d]/g,'')" placeholder="请填写容纳人数"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="isCreate">
            <el-col :span="isMB?24:16">
              <el-radio v-model="radio" :label="true" style="margin:0 14px 20px 5px;">单房号</el-radio>
              <el-input size="mini" v-model="data.DormitoryNumber" :disabled="!radio" placeholder="请填写房号" :style="isMB?'width:auto;':'width:185px;'"></el-input>
            </el-col>
          </el-row>
          <template v-else>
            <el-row>
              <el-col :span="isMB?24:12">
                <el-form-item label="楼层" prop="DormitoryFloor">
                  <el-input size="mini" v-model="data.DormitoryFloor" oninput ="value=value.replace(/[^\d]/g,'')" type="number" placeholder="请填写楼层"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="isMB?24:12">
                <el-form-item label="单房号" prop="DormitoryNumber">
                  <el-input size="mini" v-model="data.DormitoryNumber" placeholder="请填写房号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <el-row v-if="isCreate">
            <el-col :span="isMB?24:24">
              <el-radio v-model="radio" :label="false" style="margin:0 10px 0 5px;">批量房号</el-radio>
              楼层
              <el-input size="mini" v-model="data.StartFloor" type="number" :disabled="radio" style="width:50px;margin: 0 5px;"></el-input> - 
              <el-input size="mini" v-model="data.EndFloor" type="number" :disabled="radio" style="width:50px;margin: 0 5px;"></el-input>
              <br v-if="isMB"><span style="margin: 8px;">每层房间数</span>
              <el-input size="mini" v-model="data.RoomCount" :disabled="radio==1" placeholder="请填写房间数" :style="isMB?'margin-top:10px;width:185px;':'width:140px;'"></el-input>
            </el-col>
          </el-row>
          <template v-else>
            <el-row>
              <el-col :span="24">
                <div class="row-tb-head">
                  <span>管理人员列表</span>
                  <div style="float: right;">
                    <el-button type="primary" icon="el-icon-plus" @click="addEmp">添加</el-button>
                    <el-button type="danger" @click="delEmps">删除</el-button>
                  </div>
                </div>
                <el-table ref="tb_emp" class="tb-c-head" :data="tableData" border>
                  <el-table-column type="selection" width="40px" align="center" />
                  <el-table-column label="人员名称" prop="TeacherName" align="center" />
                  <el-table-column label="操作" align="center" fixed="right" width="60px">
                    <template slot-scope="{row,$index}">
                      <el-button type="text" @click="delEmp(row,$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
            <el-row style="margin-top:10px;">
              <el-col :span="24">
                <div class="row-tb-head">
                  <span>考勤机列表</span>
                  <div style="float: right;">
                    <el-button type="primary" icon="el-icon-plus" @click="addDevice">添加</el-button>
                    <el-button type="danger" @click="delDevices">删除</el-button>
                  </div>
                </div>
                <el-table ref="tb_dev" class="tb-c-head" :data="tableData2" border>
                  <el-table-column type="selection" width="40px" align="center" />
                  <el-table-column label="设备编号" prop="DeviceNo" align="center"/>
                  <el-table-column label="设备位置" prop="Place" align="center"/>
                  <el-table-column label="操作" align="center" fixed="right" width="60px">
                    <template slot-scope="{row,$index}">
                      <el-button type="text" @click="delDevice(row,$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </template>
        </el-row>
      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable multiple :show-other="false" @select-multiple="setEmps" />
    <device-dialog ref="deviceDialog" in-dialog selectable multiple @select-multiple="setDevices" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/fa/teacher/listDialog";
import deviceDialog from "@/components/attendance/device/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
    deviceDialog
  },
  watch: {
    radio(nv) {
      if(nv) {
        this.data.StartFloor = null
        this.data.EndFloor = null
        this.data.RoomCount = null
      } else {
        this.data.DormitoryNumber = ""
      }
    }
  },
  data() {
    return {
      data: {
        DormitoryId: 0,
        DormitoryAddr: "",
        DormitoryNumber: "",
        DormitoryFloor: null,
        Capacity: null,
        StartFloor: 1,
        EndFloor: 1,
        RoomCount: 1,
        Emps: [],
        Devices: [],
      },
      tableData: [],
      delList: [],
      tableData2: [],
      delList2: [],
      api: require("@/api/lo/dorm").default,
      isMB: this.$store.state.isMB,
      gradeList: [],
      radio: true,
      isCreate: true,
      rules: {
        DormitoryAddr: [{ required: true, message: "请填写宿舍地址" }],
        Capacity: [{ required: true, message: "请填写容纳人数" }],
        DormitoryFloor: [{ required: true, message: "请填写楼层" }],
        DormitoryNumber: [{ required: !this.isCreate, message: "请填写单房号" }]
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.isCreate = true
    },
    onEditOpened(data) {
      this.isCreate = false;
      data.Emps.forEach(e => {
        e.T = 1;
      })
      this.tableData = data.Emps;
      data.Devices.forEach(e => {
        e.T = 1;
      })
      this.tableData2 = data.Devices;
    },
    addEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmps(data) {
      if(data.length == 0) return;
      var same = [];
      data.forEach(e => {
        var obj = this.tableData.find(x => {
          return x.TeacherId == e.TeacherId;
        })
        if(obj) {
          same.push(e.TeacherName);
        } else {
          this.tableData.push({
            DormitoryEmpId: 0,
            DormitoryId: this.data.DormitoryId,
            TeacherId: e.TeacherId,
            TeacherName: e.TeacherName,
            T: 0,
          });
        }
      })
      if(same.length) {
        this.$message.error("已存在相同的人员：" + same.join("，"));
      }
    },
    delEmps() {
      var rows = this.$refs.tb_emp.selection;
      if(rows.length==0) {
        this.$message.error("请选择要删除的数据");
        return;
      }
      var ids = rows.map(x => x.TeacherId);
      ids.forEach(e => {
        var obj = this.tableData.find(x => x.TeacherId == e);
        var index = this.tableData.findIndex(x => x.TeacherId == e);
        if(index > -1) {
          this.delEmp(obj,index);
        }
      })
    },
    delEmp(row,index) {
      if(!(row.T===0)) {
        row.T = 2;
        this.delList.push(row);
      }
      this.tableData.splice(index,1);
    },
    addDevice() {
      this.$refs.deviceDialog.open().then((that) => {
        that.getData();
      });
    },
    setDevices(data) {
      if(data.length == 0) return;
      var same = [];
      data.forEach(e => {
        var obj = this.tableData2.find(x => {
          return x.DeviceId == e.DeviceId;
        })
        if(obj) {
          same.push(e.DeviceNo);
        } else {
          this.tableData2.push({
            DeviceDormitoryId: 0,
            DormitoryId: this.data.DormitoryId,
            DeviceId: e.DeviceId,
            DeviceNo: e.DeviceNo,
            Place: e.Place,
            T: 0,
          });
        }
      })
      if(same.length) {
        this.$message.error("已存在相同的设备：" + same.join("，"));
      }
    },
    delDevices() {
      var rows = this.$refs.tb_dev.selection;
      if(rows.length==0) {
        this.$message.error("请选择要删除的数据");
        return;
      }
      var ids = rows.map(x => x.DeviceId);
      ids.forEach(e => {
        var obj = this.tableData2.find(x => x.DeviceId == e);
        var index = this.tableData2.findIndex(x => x.DeviceId == e);
        if(index > -1) {
          this.delDevice(obj,index);
        }
      })
    },
    delDevice(row,index) {
      if(!(row.T===0)) {
        row.T = 2;
        this.delList2.push(row);
      }
      this.tableData2.splice(index,1);
    },
    onBeforeSave() {
      if(!(this.data.Capacity > 0 && this.data.Capacity %1 == 0)) {
        this.$message.error("容纳人数需为正整数")
        return false
      }
      if(this.radio) {
        if(!this.data.DormitoryNumber) {
          this.$message.error("请填写单房号")
          return false
        }
      } else {
        if(!(this.data.StartFloor >= 0 && this.data.StartFloor %1 == 0)) {
          this.$message.error("楼层需为正整数")
          return false
        }
        if(!(this.data.EndFloor >= this.data.StartFloor && this.data.EndFloor %1 == 0)) {
          this.$message.error("请填写")
          return false
        }
        if(!(this.data.RoomCount > 0 && this.data.RoomCount %1 == 0)) {
          this.$message.error("房间数需为正整数")
          return false
        }
      }
      if(!this.isCreate) {
        var td = this.tableData;
        var dl = this.delList;
        this.data.Emps = td.concat(dl);
        var td2 = this.tableData2;
        var dl2 = this.delList2;
        this.data.Devices = td2.concat(dl2);
      }
    },
    onClosed() {
      this.tableData = [];
      this.delList = [];
      this.tableData2 = [];
      this.delList2 = [];
    },
  },
};
</script>
<style lang="scss">
</style>